import React, { useContext, useEffect, useState } from 'react'
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import DriedFruitsProduct from 'models/DriedFruitsProduct'
import {
  packagingInitialState,
  driedFruitsTypeOptions,
  packageTypeOptions,
} from './constants'
import { Col, Row, Input, FormGroup, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import Switch from 'react-switch'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const DriedFruitsPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, onChange, setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        DFType,
        DFPackageType,
        DFSize,
        Organic,
        MultiPackageType,
        MultiPackageCount,
        NoAdditionalIngredients,
        otherType,
        otherPackageType,
      } = current
      setPackaging({
        category,
        subCategory,
        DFType: {
          value: DFType || '',
          label: DFType.length > 0 ? DFType : 'Type',
        },
        DFPackageType: {
          value: DFPackageType || '',
          label: DFPackageType.length > 0 ? DFPackageType : 'Type',
        },
        DFSize,
        Organic,
        MultiPackageType: MultiPackageType ?? false,
        MultiPackageCount,
        NoAdditionalIngredients,
        otherType,
        otherPackageType,
      })
    } else if (!updating) {
      setCurrent(DriedFruitsProduct)
    }
    console.log(current)
    // eslint-disable-next-line
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.DFPackageType === 'Other') {
        methods.setValue('otherPackageType', current.otherPackageType)
      }
      if (current?.DFType === 'Other') {
        methods.setValue('otherType', current.otherType)
      }
      if (current?.MultiPackageType) {
        methods.setValue('MultiPackageCount', current.MultiPackageCount)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updating])

  return (
    <Row>
      <Col xs={4}>
        <p>
          <strong>Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={driedFruitsTypeOptions}
          name="DFType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Type'}
          onChange={([selected]) => {
            setSelect(selected, 'DFType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="DFType"
            message={'⚠ Dried fruit type is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {current?.DFType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Type exceeds 15 characters.',
                },
              }}
              onKeyDown={(e) => {
                if (isNotAlpha(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size of Individual Package {asterisk}</strong>
          </p>
        </FormGroup>
        <Controller
          as={Input}
          name="DFSize"
          placeholder={'ounces'}
          control={methods.control}
          rules={{ required: true, maxLength: 5 }}
          onKeyDown={(e) => {
            if (isNotNumericDecimal(e.key)) {
              e.preventDefault()
            }
          }}
          onChange={([event]) => {
            onChange(event)
            return event
          }}
        />
        <p className={'text-danger'}>
          {methods.errors.DFSize &&
            methods.errors.DFSize.type === 'required' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Size is required.
              </Alert>
            )}
          {methods.errors.DFSize &&
            methods.errors.DFSize.type === 'maxLength' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Size exceeds 5 characters.
              </Alert>
            )}
        </p>
      </Col>
      <Col xs={4}>
        <p>
          <strong>Package Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packageTypeOptions}
          name="DFPackageType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Package Type'}
          onChange={([selected]) => {
            setSelect(selected, 'DFPackageType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="DFPackageType"
            message={'⚠ Package type is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {current?.DFPackageType === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Package Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherPackageType"
              placeholder={'Other Package Type'}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 15,
                  message: '⚠ Other Package Type exceeds 15 characters.',
                },
              }}
              onKeyDown={(e) => {
                if (isNotAlpha(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherPackageType"
                message={'Other package type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <p>
          <strong>Multi-pack</strong>
        </p>
        <Controller
          as={Switch}
          name="MultiPackageType"
          id="MultiPackageType"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.MultiPackageType}
        />
        <br />
        <br />
        <br />
        {current?.MultiPackageType === true && (
          <FormGroup>
            <p>
              <strong>Multi-pack Count {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="MultiPackageCount"
              placeholder={'Multi-pack Count'}
              onKeyDown={(e) => {
                if (
                  ![
                    'Backspace',
                    'Delete',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                  ].includes(e.key) &&
                  isNaN(parseInt(e.key))
                ) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: { value: 2, message: '⚠ 2 characters max.' },
                required: {
                  value: true,
                  message: '⚠ Multi Pack Count is required.',
                },
                validate: (MultiPackageCount) => MultiPackageCount > 0,
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="MultiPackageCount"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
      </Col>
      <Col xs={4}>
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.Organic}
        />
        <br />
        <hr />
        <p>
          <strong>
            I certify that this product contains NO added sugars, fats, oils, or
            artificial or natural flavors inluding essences. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="NoAdditionalIngredients"
          id="NoAdditionalIngredients"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          defaultValue={packaging.NoAdditionalIngredients}
          rules={{
            validate: (NoAdditionalIngredients) =>
              NoAdditionalIngredients === true,
          }}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="NoAdditionalIngredients"
            message={
              '⚠ Product must contain NO sugars, fats, oils, or artificial or natural flavors including essences.'
            }
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default DriedFruitsPackage
